import { Typography } from 'antd';
import React from 'react';
import { PermissionEnum } from '../../../enums/permission';
import usePermission from '../../../hooks/usePermission';
import CustomerList from '../components/CustomerList';

const Customer: React.FC = () => {
  const { checkPermission } = usePermission();
  return (
    <div>
      <Typography.Title level={4} style={{ fontWeight: 700, margin: 0 }}>
        Customer account
      </Typography.Title>
      { checkPermission([PermissionEnum.code.customerViewList])
        && <CustomerList />}
    </div>
  );
};
export default Customer;
